import { createWebHistory, createRouter } from "vue-router";
import NotFoundPage from "@/pages/NotFoundPage";
import AuthPage from "@/pages/AuthPage";
import LoginPage from "@/pages/LoginPage";
import RecoveryPage from "@/pages/RecoveryPage";
import ResetPassword from "@/pages/ResetPassword";
import RegisterPage from "@/pages/RegisterPage";
import OnboardPage from "@/pages/OnboardPage";
import ProfilePage from "@/pages/ProfilePage";
import WorkspacePage from "@/pages/WorkspacePage";
import AllWorkspacesPage from "@/pages/AllWorkspacesPage";
import AmazonSellerCentralPage from "@/pages/AmazonSellerCentralPage";
import AmazonConnectionPage from "@/pages/AmazonConnectionPage";
import AmazonAdvertisingPage from "@/pages/AmazonAdvertisingPage";
import ConnectionSuccessPage from "@/pages/ConnectionSuccessPage";
import ConnectionFailedPage from "@/pages/ConnectionFailedPage";
import AmazonAdsAccountSelectionPage from "@/pages/AmazonAdsAccountSelectionPage";
import AmazonDSPAdsAccountSelectionPage from "@/pages/AmazonDSPAdsAccountSelectionPage";
import SEOPage from "@/pages/SEOPage";
import ProductAnalyticsPage from "@/pages/ProductAnalyticsPage";
import DemandForecastingPage from "@/pages/DemandForecastingPage";
import ProductDataPage from "@/pages/ProductDataPage";
import CogsDataPage from "@/pages/CogsDataPage";
import PPCManagementPage from "@/pages/PPCManagementPage";
import ConnectionsPage from '@/pages/ConnectionsPage';
import ConnectionsPageV2 from '@/pages/ConnectionsPageV2';
import ProfitAndLossPage from "@/pages/ProfitAndLossPage";
import AlertsPage from '@/pages/AlertsPage';
import DashboardV2Page from "@/pages/DashboardV2Page";
import PricingAndMarginPage from "@/pages/PricingAndMarginPage";
import PricingAndMarginPageV2 from "@/pages/PricingAndMarginPageV2";
import InventoryCoveragePage from "@/pages/InventoryCoveragePage.vue";
import MarketingInsightsPage from "@/pages/MarketingInsightsPage.vue";
import CustomerInsightsPage from "@/pages/CustomerInsightsPage.vue";
import SearchFunnelPage from "@/pages/SearchFunnelPage.vue";
import BrandPortfolioPage from "@/pages/BrandPortfolioPage.vue";
import { tryParse, isObjectEmpty, EVENTS } from "@/utils";
import LoginPageV2 from "@/pages/LoginPageV2.vue";
import RecoveryPageV2 from "@/pages/RecoveryPageV2.vue";
import DSPReportingPage from "@/pages/DSPReportingPage.vue";
import ResetPasswordV2 from "@/pages/ResetPasswordV2.vue";
import OnboardPageV2 from "@/pages/OnboardPageV2.vue";

/*eslint no-unused-vars: ["error", { "args": "none" }]*/

function preventDirectNavigationToThisRoute(to, from, next) {
  if (sessionStorage.getItem(to.path) !== "true") {
    // reject the navigation
    next({
      name: "Login"
    });
  } else {
    sessionStorage.setItem(to.path, false);
    next();
  }
}
function resetLocalStorageIfNeeded(to, from, next) {
  if (from.meta?.menuName != 'Inventory' && to.meta?.menuName == 'Inventory') {
    let current_workspace = tryParse(localStorage.getItem("current_workspace"));
    if (!isObjectEmpty(current_workspace)) {
      localStorage.setItem(current_workspace?.workspace_id + "sellers_filter", JSON.stringify({}));
    }
  }
}
function preventNavigationInactiveFeatures(to, from, next) {
  if (!router.$feature.isVisible(to.meta.featureName)) {
    next({
      name: "Login"
    }); //cancel the navigation as this feature is not visible to user
  } else {
    next();
  }
}
function trackRouteEntry(to) {
  const nonContainedTo = {
    "/connections": {
      meta: {
        event: "connectionsModuleOpened"
      }
    }
  };
  //console.log("Emitting tracking for ", to.meta.event, to, )
  if (to.meta.event) {
    window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
      event_name: to.meta.event,
      properties: {}
    });
  }
}
const routes = [{
  path: "/",
  meta: {
    requiresAuth: true,
    featureName: "default"
  },
  component: AuthPage,
  children: [{
    path: "",
    name: "Dashboard",
    component: DashboardV2Page,
    meta: {
      requiresAuth: true,
      breadcrumb: "Dashboard",
      featureName: "default",
      event: "dashboardModuleOpened"
    }
  }, {
    path: "amz-seller-central",
    meta: {
      requiresAuth: true,
      featureName: "default"
    },
    children: [{
      path: "",
      name: "AmazonSellerCentral",
      component: AmazonSellerCentralPage,
      meta: {
        requiresAuth: true,
        breadcrumb: "AmazonSellerCentral",
        featureName: "default"
      }
    }]
  }, {
    path: "amz-advertising",
    meta: {
      requiresAuth: true,
      featureName: "default"
    },
    children: [{
      path: "",
      name: "AmazonAdvertising",
      component: AmazonAdvertisingPage,
      meta: {
        breadcrumb: "AmazonAdvertising",
        featureName: "default"
      }
    }]
  }, {
    path: "amz-vendor-central",
    meta: {
      requiresAuth: true,
      featureName: "default"
    },
    children: [{
      path: "",
      name: "AmazonVendorCentral",
      component: AmazonSellerCentralPage,
      meta: {
        breadcrumb: "AmazonVendorCentral",
        featureName: "default"
      }
    }]
  }, {
    path: "seo",
    meta: {
      requiresAuth: true,
      featureName: "default"
    },
    children: [{
      path: "",
      name: "SEO",
      meta: {
        requiresAuth: true,
        breadcrumb: "Content",
        featureName: "default",
        menuName: "Products"
      },
      component: SEOPage
    }, {
      path: "/pricing-and-margin",
      name: "Pricing and Margin",
      meta: {
        requiresAuth: true,
        breadcrumb: "Pricing and Margin",
        featureName: "default",
        menuName: "Products",
        event: "pricingAndMarginModuleOpened"
      },
      component: PricingAndMarginPageV2
    }, {
      path: "/cogs-data",
      name: "CogsData",
      meta: {
        requiresAuth: true,
        breadcrumb: "COGS",
        featureName: "cogsdatafeature",
        menuName: "Products",
        event: "cogsModuleOpened"
      },
      component: CogsDataPage
    }]
  }, {
    path: "inventory",
    meta: {
      requiresAuth: true,
      featureName: "inventoryfeature"
    },
    children: [{
      path: "/demand-forecasting",
      name: "DemandForecasting",
      meta: {
        requiresAuth: true,
        breadcrumb: "DemandForecasting",
        featureName: "demandforecastingfeature",
        menuName: "Inventory",
        event: "demandForecastingModuleOpened"
      },
      component: DemandForecastingPage
    }, {
      path: "/product-data",
      name: "ProductData",
      meta: {
        requiresAuth: true,
        breadcrumb: "Product Data",
        featureName: "productdatafeature",
        menuName: "Inventory",
        event: "productDataModuleOpened"
      },
      component: ProductDataPage
    }, {
      path: "/inventory-coverage",
      name: "Inventory Coverage",
      meta: {
        requiresAuth: true,
        breadcrumb: "Inventory Coverage",
        featureName: "productdatafeature",
        menuName: "Inventory",
        event: "inventoryCoverageModuleOpened"
      },
      component: InventoryCoveragePage,
      beforeEnter: [preventNavigationInactiveFeatures]
    }]
  }, {
    path: "product-analytics",
    name: "ProductAnalytics",
    meta: {
      requiresAuth: true,
      featureName: "productfeature"
    },
    component: ProductAnalyticsPage,
    beforeEnter: [preventNavigationInactiveFeatures]
  }, {
    path: "ads",
    meta: {
      requiresAuth: true,
      featureName: "default"
    },
    children: [{
      path: "/advertising",
      name: "Advertising",
      meta: {
        requiresAuth: true,
        breadcrumb: "PPC Management",
        featureName: "advertisingv2feature",
        menuName: "Advertising",
        event: "sponsoredAdsModuleOpened"
      },
      component: PPCManagementPage,
      beforeEnter: [preventNavigationInactiveFeatures]
    }, {
      path: "/dsp",
      name: "DSP",
      meta: {
        requiresAuth: true,
        breadcrumb: "DSP",
        featureName: "dspmodulefeature",
        menuName: "DSP",
        event: "dspModuleOpened"
      },
      component: DSPReportingPage,
      beforeEnter: [preventNavigationInactiveFeatures]
    }]
  }, {
    path: "profit-and-loss",
    name: "ProfitAndLoss",
    meta: {
      requiresAuth: true,
      breadcrumb: "Profit and Loss",
      featureName: "profitandlossfeature",
      menuName: "Profit and Loss",
      event: "profitAndLossModuleOpened"
    },
    component: ProfitAndLossPage,
    beforeEnter: [preventNavigationInactiveFeatures]
  }, {
    path: "market-insights",
    meta: {
      requiresAuth: true,
      featureName: "marketinsightsfeature"
    },
    children: [{
      path: "/market-share",
      name: "Market Share",
      meta: {
        requiresAuth: true,
        breadcrumb: "Market Share",
        featureName: "marketsharefeature",
        menuName: "Market Insights",
        event: "marketDynamicsCategoryModuleOpened"
      },
      component: MarketingInsightsPage,
      beforeEnter: [preventNavigationInactiveFeatures]
    }, {
      path: "/search-funnel",
      name: "Search Funnel",
      meta: {
        requiresAuth: true,
        breadcrumb: "Search Funnel",
        featureName: "searchfunnelfeature",
        menuName: "Market Insights",
        event: "searchFunnelModuleOpened"
      },
      component: SearchFunnelPage,
      beforeEnter: [preventNavigationInactiveFeatures]
    }]
  }, {
    path: "customer-insights",
    name: "Customer Insights",
    meta: {
      requiresAuth: true,
      breadcrumb: "Customer Insights",
      featureName: "customerinsightsfeature",
      menuName: "Customer Insights",
      event: "customerInsightsModuleOpened"
    },
    component: CustomerInsightsPage,
    beforeEnter: [preventNavigationInactiveFeatures]
  }, {
    path: 'alerts-page',
    name: 'Alerts',
    meta: {
      requiresAuth: true,
      breadcrumb: "Alerts",
      featureName: "alertsfeature",
      event: "alertingModuleOpened"
    },
    component: AlertsPage,
    beforeEnter: [preventNavigationInactiveFeatures]
  }, {
    path: "profile",
    name: "Profile",
    meta: {
      requiresAuth: true,
      breadcrumb: "User profile",
      featureName: "default",
      menuName: "Settings",
      event: "userProfileModuleOpened"
    },
    component: ProfilePage
  }, {
    path: "connections",
    name: "Connections",
    meta: {
      requiresAuth: true,
      breadcrumb: "Connections",
      featureName: "connectionsv2feature",
      menuName: "Settings"
    },
    beforeEnter: [preventNavigationInactiveFeatures],
    children: [{
      path: "",
      name: "ConnectionsPageV2",
      component: ConnectionsPageV2,
      meta: {
        requiresAuth: true,
        breadcrumb: "",
        featureName: "connectionsv2feature",
        event: "connectionsModuleOpened"
      },
      beforeEnter: [preventNavigationInactiveFeatures]
    }]
  }, {
    path: "account",
    name: "Accounts",
    meta: {
      requiresAuth: true,
      breadcrumb: "Account",
      featureName: "default",
      menuName: "Settings"
    },
    children: [{
      path: "",
      name: "WorkspacePage",
      component: WorkspacePage,
      meta: {
        requiresAuth: true,
        featureName: "default",
        event: "accountManagementModuleOpened"
      }
    }]
  }, {
    path: "manage-accounts",
    name: "Manage Accounts",
    meta: {
      requiresAuth: true,
      breadcrumb: "Manage Accounts",
      featureName: "manageaccountsfeature",
      menuName: "Settings"
    },
    component: AllWorkspacesPage,
    beforeEnter: [preventNavigationInactiveFeatures]
  }, {
    path: "/brand-portfolio",
    name: "BrandPortfolio",
    meta: {
      requiresAuth: true,
      breadcrumb: "Brand Portfolio",
      featureName: "brandportfoliofeature",
      menuName: "Settings"
    },
    component: BrandPortfolioPage,
    beforeEnter: [preventNavigationInactiveFeatures]
  }]
}, {
  path: "/login",
  name: "Login",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: LoginPageV2
}, {
  path: "/register",
  name: "Register",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: RegisterPage
}, {
  path: "/recovery",
  name: "Recovery",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: RecoveryPageV2
}, {
  path: "/user/password-reset",
  name: "ResetPassword",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: ResetPasswordV2
}, {
  path: "/onboard",
  name: "Onboard",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: OnboardPageV2
}, {
  path: "/amz-advertising/select-profiles",
  name: "AmazonAdsAccountSelectionPage",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: AmazonAdsAccountSelectionPage
}, {
  path: "/amz-advertising/select-dsp-profiles",
  name: "AmazonDSPAdsAccountSelectionPage",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: AmazonDSPAdsAccountSelectionPage
}, {
  path: "/connections/success",
  name: "ConnectionsSuccessPage",
  meta: {
    requiresAuth: true,
    featureName: "default"
  },
  component: ConnectionSuccessPage,
  beforeEnter: []
}, {
  path: "/connections/failed",
  name: "ConnectionsFailedPage",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: ConnectionFailedPage,
  beforeEnter: []
}, {
  path: "/:pathMatch(.*)",
  name: "NotFound",
  meta: {
    requiresAuth: false,
    featureName: "default"
  },
  component: NotFoundPage
}];

// {
//     path: '/onboard/:email',
//     name: 'Onboard',
//     component: OnboardPage,
// }

let router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// router.beforeEach(async(to, from, next) => {
//     const store = await
//     import ('@/store');
//     var is_authenticated = store.default.getters.getAuthState()
//     if ((to.path !== '/login' && to.path !== 'login') && !is_authenticated) {
//         next({ path: '/login' })
//     } else
//     if ((to.path === '/login' || to.path === 'login') && is_authenticated) {
//         next({ path: '/' })
//     } else {
//         next()
//     }
// })

const redirectToLogin = route => {
  const LOGIN = "/login";
  if (route.name != LOGIN) {
    return {
      path: LOGIN,
      replace: true,
      query: {
        redirectFrom: route.fullPath
      }
    };
  }
};

// const redirectToHome = route => {
//     const HOME = '/';
//     return { path: HOME, replace: true };
// };

router.beforeEach(async (to, from, next) => {
  //const store = await import('@/store');
  //var is_authenticated = await store.default.getters.getAuthState();
  window.auth_user = await router.$store.getters.getAuthUser(false);
  var is_authenticated = await router.$store.getters.getAuthState(false);
  //console.log("Is Authenticated: ", is_authenticated);
  const requiresAuth = to.matched.some(route => route.meta && route.meta.requiresAuth);
  if (!is_authenticated && to.fullPath === "/") {
    router.push(redirectToLogin(to));
  }
  if (!is_authenticated && requiresAuth) {
    // Push to login
    router.replace(redirectToLogin(to));
  }
  resetLocalStorageIfNeeded(to, from, next);
  trackRouteEntry(to);
  // Jump to the route `to` if the user is authenticated
  next();
});
export default router;